<template>
    <div id="inquiry-page">
        <!-- HEADER -->
        <div class="action-header">
            <div class="search-container">
                <div class="search-input">
                    <v-text-field
                        v-model="search"
                        prepend-inner-icon="search"
                        :placeholder="this.$vuetify.lang.t('$vuetify.inquiry.searchByEmployeeName')"
                        solo
                        height="40px"
                        @keyup.enter="getInquiriesPagination()">
                    </v-text-field>
                </div>

                <div class="ml-3">
                    <v-btn
                        @click="searchInquiries()"
                        height="40px"
                        color="primary"
                        outlined>
                        {{ $vuetify.lang.t('$vuetify.inquiry.search') }}
                    </v-btn>
                </div>

                <div class="ml-day-inquiry">
                    <v-select
                        @change="getInquiriesPagination()"
                        v-model="laoStatus"
                        item-text="text"
                        item-value="value"
                        :items="statusList"
                        outlined
                        height="40px"
                        background-color="#ffffff">
                    </v-select>
                </div>

                <div class="ml-day-inquiry">
                    <v-menu
                        ref="inquiryDayMenu"
                        v-model="datePickerShow"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="234px">
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                prepend-inner-icon="event"
                                @click:prepend-inner="datePickerShow = true"
                                v-model="dateFormatted"
                                readonly
                                v-on="on"
                                outlined
                                height="40px"
                                background-color="#ffffff"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            :locale="localeLang"
                            ref="inquireDatePicker"
                            v-model="inquireDate"
                            @change="saveInquireDate"
                        ></v-date-picker>
                    </v-menu>
                </div>
            </div>
        </div>
        <!-- END HEADER -->

        <!-- DATATABLE -->
        <v-card class="content-container">
            <v-data-table
                :footer-props="{
                    'items-per-page-options': [10, 20, 30, 50, 100]
                }"
                @page-count="pageCount = $event"
                :page.sync="page"
                :headers="headers"
                :options.sync="options"
                :server-items-length="totalData"
                :items="items"
                @click:row="handleClick"
                :loading="loading">
                <template v-slot:[`item.status`]="{ item }">
                    <span
                        :class="isPending(item.status['key'])">
                        {{ item.status['value'] }}
                    </span>
                </template>
            </v-data-table>
        </v-card>
        <!-- END DATATABLE -->

        <!-- PAGINATION -->
        <div class="pt-2 paginator-box">
            <div>
                <v-pagination v-model="page" :length="pageCount"></v-pagination>
            </div>
        </div>
        <!-- END PAGINATION -->
    </div>
</template>

<script>
import permissionConstant from '@/constants/permissions.js'

export default {
    name: 'InquiryLeave',

    data () {
        return {
            // Filter
            search: '',
            inquireDate: this.$util.getCurrentDate(),
            datePickerShow: false,
            dateFormatted: this.$util.formatDate(this.$util.getCurrentDate()),
            laoStatusItems: [],
            laoStatus: null,
            pageCount: 1,
            page: 1,
            options: {},
            items: [],
            totalData: 0,
            loading: false,
            branch: null,
            permissionUpdate: false
        }
    },

    computed: {
        localeLang () {
            return this.$vuetify.lang.current
        },
        headers () {
            return [
                { text: this.$vuetify.lang.t('$vuetify.inquiry.employeeName'), value: 'fullname', width: '20%' },
                { text: this.$vuetify.lang.t('$vuetify.inquiry.group'), value: 'group_name', width: '12%' },
                { text: this.$vuetify.lang.t('$vuetify.inquiry.department'), value: 'department_name', width: '15%' },
                { text: this.$vuetify.lang.t('$vuetify.inquiry.type'), value: 'leave_name', width: '13%' },
                { text: this.$vuetify.lang.t('$vuetify.inquiry.inquiryDate'), value: 'request_date', width: '15%' },
                // { text: this.$vuetify.lang.t('$vuetify.inquiry.period'), value: 'period_type', width: '12%' },
                { text: this.$vuetify.lang.t('$vuetify.inquiry.status'), value: 'status', width: '13%', sortable: false }
            ]
        },
        statusList () {
            const status = this.laoStatusItems
            status.unshift({
                text: this.$vuetify.lang.t('$vuetify.inquiry.allStatus'),
                value: null
            })
            return status
        }
    },

    methods: {
        async searchInquiries () {
            this.options.page = 1
            await this.getInquiriesPagination()
        },

        async getInquiriesPagination () {
            this.loading = true
            const { sortBy, sortDesc, page, itemsPerPage } = this.options

            let url = `leave-requests?branch=${this.branch}&inquireDate=${this.inquireDate}&page=${page}&itemsPerPage=${itemsPerPage}`

            if (sortBy[0]) {
                url += `&sortBy=${sortBy[0]}`
            }

            if (sortDesc[0]) {
                url += `&sortDesc=${sortDesc[0]}`
            }

            if (this.search) {
                url += `&search=${this.search}`
            }

            if (this.laoStatus) {
                url += `&inquireStatus=${this.laoStatus}`
            }

            const res = await this.axios.get(url)
            if (res && res.data && res.data.status === 'ok') {
                this.items = res.data.data
                this.totalData = res.data.total
                this.loading = false
            }
        },

        async saveInquireDate (date) {
            this.$refs.inquiryDayMenu.save(date)
            this.dateFormatted = this.$util.formatDate(date)
            await this.getInquiriesPagination()
        },

        async getBranch () {
            this.branch = localStorage.getItem('currentBranchId')
            if (this.branch) {
                await this.getInquiriesPagination()
            }
        },

        async getStatus () {
            const res = await this.axios.get('leave-or-onsite/status')
            if (res && res.data && res.data.status === 'ok') {
                this.laoStatusItems = res.data.data
            }
        },

        isPending (status) {
            let style = ''
            if (status === 'PND') {
                style += 'highlight'

                if (this.permissionUpdate) {
                    style += ' editable'
                }
            } else {
                style += 'success'
                if (this.permissionUpdate) {
                    style += ' editable'
                }
            }

            return style
        },

        checkPermission () {
            this.permissionUpdate = this.$util.checkPermission(permissionConstant.inquiry.update)
        },

        handleClick (item) {
            if (item.status.key === 'APV') {
                this.$store.dispatch('setErrorModalShow', true)
                this.$store.dispatch('setErrorModalMsg', this.$vuetify.lang.t('$vuetify.inquiry.cannotEditTheApproval'))
            } else if (item.status.key === 'REJ') {
                this.$store.dispatch('setErrorModalShow', true)
                this.$store.dispatch('setErrorModalMsg', this.$vuetify.lang.t('$vuetify.inquiry.cannotEditTheRejected'))
            } else {
                this.seeDetail(item)
            }
        },

        seeDetail ({ id }) {
            if (this.permissionUpdate && id) {
                this.$router.push({ name: 'InquiryForm', params: { id } })
            }
        }
    },

    async mounted () {
        await this.getBranch()
        this.checkPermission()
        await this.getStatus()
    },

    watch: {
        options: {
            async handler () {
                if (this.branch) {
                    await this.getInquiriesPagination()
                }
            }
        },
        '$vuetify.lang.current': {
            handler: async function (after, before) {
                if (this.branch) {
                    await this.getInquiriesPagination()
                }
                await this.getStatus()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
::v-deep .v-input__control > .v-input__slot {
    min-height: auto !important;
    display: flex !important;
    align-items: center !important;
}

::v-deep .search-input .v-input__control > .v-input__slot {
    box-shadow: none !important;
    border: 1px solid #a8a8a8 !important;
}

::v-deep .v-input__prepend-inner {
    margin: auto !important;
}

::v-deep .v-input__append-inner {
    margin-top: 0.75rem !important;
}

::v-deep .theme--light.v-data-table tbody tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
    background: #eeeeee;
    cursor: pointer;
}

.ml-day-inquiry {
    margin-left: 40px;
}

.highlight {
    padding: 0rem 1rem;
    background-color: #ff544a;
    border-radius: 25px;
    color: white;
}
.success {
    padding: 0rem 1rem;
    background-color: #5cb85c;
    border-radius: 25px;
    color: white;
}

.editable {
    cursor: pointer;
}
</style>
